<template>
	<button type="button" class="btn btn-neutral btn-square rounded-circle position-fixed bottom-0 start-0 mb-4 ms-3" @click="goBottom" v-if="display">
		<i class="bi bi-chevron-down"></i>
	</button>

	<!-- bottom sentinel -->
	<div ref="bottomEl" style="height: 1px;"></div>
</template>

<script>
	import { ref, onMounted, onUnmounted } from 'vue';
	import VueScrollTo from 'vue-scrollto';

	export default {
		setup() {
			const display = ref(false);
			const minHeight = 3000;

			const update = () => {
				const el = document.documentElement;
				display.value = el.scrollHeight > minHeight;
			}

			const goBottom = () => {
				window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
			}

			let ro = null;
			let mo = null;

			onMounted(() => {
				ro = new ResizeObserver(update);
				ro.observe(document.body);

				mo = new MutationObserver(update);
				mo.observe(document.body, { childList: true, subtree: true, characterData: true });

				window.addEventListener('resize', update, { passive: true });

				update();
			})

			onUnmounted(() => {
				if (ro) ro.disconnect();
				if (mo) mo.disconnect();
				window.removeEventListener('resize', update);
			});

			return { display, goBottom };
		}
	}
</script>